import createReactComponent from '../createReactComponent';
export default createReactComponent('flag', 'Flag', [["path",{"d":"M4 21v-5.313m0 0c5.818-4.55 10.182 4.55 16 0V4.313c-5.818 4.55-10.182-4.55-16 0z","key":"svg-0"}]]);